<section class="section dashboard" *ngIf="chartData">
  <div class="row">
    <!-- Left side columns -->
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <!-- Main figures Card starts -->
          <div class="main-fig-hld">
            <div class="date_info mb-2">
              <h2> {{"dashboard.title_db" | translate }}</h2>
            </div>

            <div class="row" *ngIf="chartData.counts">
              <!--<div class="col-lg-3">
                <div class="colored-card blue-card">
                  <a>
                    <div class="clrd-c-info aic">
                      <div class="card-fig-icon"> <img src="../../../../assets/images/active_stations.svg"> </div>
                      <div class="card-info">
                        <p> {{"dashboard.day_info" | translate}}</p>
                        <h5> {{displayDate}}</h5>
                      </div>
                    </div>
                  </a>
                </div>
              </div>-->
              <div class="col-lg-4">
                <div class="colored-card blue-card">
                  <a>
                    <div class="clrd-c-info aic">
                      <div class="card-fig-icon"> <img src="../../../../assets/images/active_station.svg"> </div>
                      <div class="card-info">
                        <p> {{"dashboard.active_stations" | translate}}</p>
                        <h2> {{chartData.counts.chargeStationCount}}</h2>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="colored-card yellow-card">
                  <a>
                    <div class="clrd-c-info aic">
                      <div class="card-fig-icon"> <img src="../../../../assets/images/total_power_consumes.svg"> </div>
                      <div class="card-info">
                        <p> {{"dashboard.total_power"| translate}}</p>
                        <h2> {{chartData.counts.energyConsumedCount}} kWh</h2>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="colored-card grey-card">
                  <a href="#">
                    <div class="clrd-c-info aic">
                      <div class="card-fig-icon"> <img src="../../../../assets/images/total_amount_details.svg"> </div>
                      <div class="card-info">
                        <p> {{"dashboard.totalAmount"| translate}}</p>
                        <h2> {{chartData.counts.revenueCount}}</h2>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Main figures Card Ends -->

        </div>
        <div class="col-lg-8">
          <div class="dash-charging-points">
            <div class="card general-card">
              <div class="card-body">
                <h5 class="card-title">
                  {{"dashboard.doughnutchart" | translate }}
                  <!--<span>/ Today</span>-->
                </h5>
                <!-- Donut Chart -->
                <div id="DoughnutChart"></div>
              </div>
            </div>
          </div>
          <div class="table-content-hold mt-4" style="padding: 0px; margin: 0px;">
            <div class="table-hld general-card">
              <h2 class="table-title"> {{"dashboard.search_alerts" | translate }} </h2>
              <table id="example" class="table table-striped" style="width:100%">
                <thead>
                  <tr>
                    <th>{{'dashboard.date'|translate}}</th>
                    <th>{{'dashboard.cp' | translate }}</th>

                    <!--<th>{{'cp.ChargePointId' | translate }}</th>-->
                    <!--<th>{{'cp.Connector' | translate}}</th>-->
                    <th>{{'message' | translate}} </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let alert of alerts">
                    <td> {{alert.createdOn | date :'dd/MM/yyyy' }} {{_sharedService.convertIntoTime(alert.createdOn)}}</td>
                    <td><a class="sm-hl" [routerLink]="['/CP/page/Profile/', alert.chargePointId]">{{alert.chargePointName}}</a> </td>

                    <!--<td>{{alert.chargePointId}}</td>-->
                    <!--<td>{{alert.connector}}</td>-->
                    <td>{{alert.message}}</td>
                  </tr>
                  <ng-container *ngIf="alerts.length == 0">
                    <tr>
                      <td class="dataTables-empty" colspan="3">
                        {{'transaction.NoDataFound' | translate }}
                      </td>
                    </tr>
                  </ng-container>
                  <!--<tr>
                    <td>9840239</td>
                    <td>TATA , West Bay, Doha</td>
                    <td>Tata Power</td>
                    <td>EC-Charger</td>
                    <td>AC Type 1 20 Kwh.  DC Type 2 - 20 Kwh</td>
                    <th> <span class="tbl-status-green tbl-status"> Active </span></th>
                    <th><a href="#"> <img src="../../../../assets/images/view_alert.svg" /> </a></th>
                    <th> <a href="#" class="yellow-btn action-btn"> Details </a> </th>
                  </tr>-->
                </tbody>
              </table>
              <div class="px-4">
                <a class="float-end mb-3" [routerLink]="['/Alerts/page/Search']">
                  {{'view_all' | translate}}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <form [formGroup]="form">
            <div class=" card general-card">
              <!--<div class="row master-filter-hold">
                <div class="col-7">
                  <div class="master-filter">
                    <select class="form-select small-textbox" formControlName="DateTypeId" aria-label="Default select example" (change)="filterCharts()">
                      <option value="0">{{"dashboard.today" | translate}}</option>
                      <option value="1">{{"dashboard.thismonth" | translate}}</option>
                      <option value="2">{{"dashboard.thisyear" | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-5 day-info">
                  <p> {{displayDate}}</p>
                </div>
              </div>-->
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card general-card">
                  <div class="card-body">
                    <div class="date_val">
                      <i class="bi bi-calendar2-week"></i>
                      <span> {{displayDate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card general-card">
                  <div class="card-body">
                    <div class="filter-select">
                      <div class="row">
                        <div class="col-6">
                          <select class="form-select small-textbox" formControlName="TypeCSId" aria-label="Default select example" (change)="getDashboardData(form.get('TypeCSId')?.value, true,chartNumberEnum.ChargeStations)">
                            <option value="2">{{'dashboard.revenue' | translate }}</option>
                            <option value="1">{{'dashboard.energey_consumed' | translate }}</option>
                            <option value="0">{{'dashboard.transaction_count' | translate }}</option>
                          </select>
                        </div>
                        <div class="col-6">
                          <div class="master-filter">
                            <select class="form-select small-textbox" formControlName="DateTypeId" aria-label="Default select example" (change)="filterCharts()">
                              <option value="0">{{"dashboard.today" | translate}}</option>
                              <option value="1">{{"dashboard.thismonth" | translate}}</option>
                              <option value="2">{{"dashboard.thisyear" | translate}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Column Chart -->
                    <div id="ChartCSVsTransaction"></div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="card general-card">
                  <div class="card-body">
                    <div class="filter-select">
                      <div class="row">
                        <div class="col-6">
                          <select class="form-select small-textbox" formControlName="TypeTimeId" aria-label="Default select example" (change)="getDashboardData(form.get('TypeTimeId')?.value, true,chartNumberEnum.Time)">
                            <option value="2">{{'dashboard.revenue' | translate }}</option>
                            <option value="1">{{'dashboard.energey_consumed' | translate }}</option>
                            <option value="0">{{'dashboard.transaction_count' | translate }}</option>
                          </select>
                        </div>
                        <div class="col-6">
                          <div class="master-filter">
                            <select class="form-select small-textbox" formControlName="DateTypeId" aria-label="Default select example" (change)="filterCharts()">
                              <option value="0">{{"dashboard.today" | translate}}</option>
                              <option value="1">{{"dashboard.thismonth" | translate}}</option>
                              <option value="2">{{"dashboard.thisyear" | translate}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Column Chart -->
                    <div id="ChartTimeVsTransaction"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End Left side columns -->
  </div>
</section>

<app-access-denied *ngIf="chartData != undefined && !chartData"></app-access-denied>

